import React from "react"
import { Box, Typography, InfoIcon, Alert, useTheme } from "@carrotfertility/carotene-core"
import { FormButton } from "@carrotfertility/carotene-core-x"

type FormNavigationProps = {
  onBack: () => void
  onCancel: () => void
  inReview: boolean
}

export function FormNavigation({ onBack, onCancel, inReview }: FormNavigationProps): JSX.Element {
  const theme = useTheme()

  return (
    <Box display="flex" flexDirection="column" justifyContent="space-between">
      {inReview && (
        <Alert severity="info" icon={<InfoIcon />} sx={{ marginBottom: theme.spacing(theme.tokens.spacing.sm) }}>
          <Typography variant="body2">{"Once submitted, the plan is live on the member's homepage"}</Typography>
        </Alert>
      )}
      <Box display="flex" justifyContent="space-between">
        <FormButton type="button" sx={{ marginRight: "auto" }} variant="text" onClick={onCancel}>
          Cancel
        </FormButton>
        {inReview && (
          <FormButton
            type="button"
            sx={{ marginRight: theme.spacing(theme.tokens.spacing.xs) }}
            variant="outlined"
            color="secondary"
            onClick={onBack}
          >
            Back
          </FormButton>
        )}
        <FormButton type="submit">{inReview ? "Submit" : "Save and continue"}</FormButton>
      </Box>
    </Box>
  )
}
